// This file automatically generated by skymarshal.
// DO NOT MODIFY BY HAND!!!!
//
// From Source File: infrastructure/skybus_tunnel/lcmtypes/web_socket_msg_t.lcm


import Long from "long";
import Decoder from "@skydio/lcm/src/decoder";
import Encoder from "@skydio/lcm/src/encoder";
import LcmMsg from "@skydio/lcm/src/lcm";
import ReflectionMeta from "@skydio/lcm/src/reflection";

export class web_socket_msg_t extends LcmMsg {

  private static _hash = Long.fromString("967036592908991517", true);
  private static _packed_fingerprint?: Long;

  /** @internal */
  public static override _get_packed_fingerprint(): Long {
    if (web_socket_msg_t._packed_fingerprint === undefined) {
      web_socket_msg_t._packed_fingerprint = web_socket_msg_t._get_hash_recursive([]);
    }
    return web_socket_msg_t._packed_fingerprint;
  }

  /** @internal */
  public static override _get_hash_recursive(parents: any[]): Long {
    if (parents.indexOf(web_socket_msg_t) > -1) {
      return Long.fromNumber(0, true);
    }
    let tmp_hash = web_socket_msg_t._hash;
    return tmp_hash.shl(1).add(tmp_hash.shru(63));
  }

  /** @internal */
  public static override _reflection_meta: ReflectionMeta = {
    channel: { kind: "primitive", type: String, typeStr: "string" },
    encoded_msg: { kind: "bytes", dims: [{ kind: "auto" }], nDim: 1 },
  };

  public channel: string;
  public encoded_msg: Uint8Array;

  public override decode(byte_array: Uint8Array): web_socket_msg_t {
    const decoder = new Decoder(new DataView(
      byte_array.buffer, byte_array.byteOffset, byte_array.byteLength
    ));
    const hash = decoder.decode_hash();
    if (!hash.equals(web_socket_msg_t._get_packed_fingerprint())) {
      console.error("Hash mismatch", hash, web_socket_msg_t._get_packed_fingerprint());
      throw new Error("Hash mismatch!");
    }
    this.decode_one(decoder);
    return this;
  }

  public override decode_one(decoder: Decoder): web_socket_msg_t {
    this.channel = decoder.decode_string();
    this.encoded_msg = decoder.decode_uint8_array([decoder.decode_int32_t()]);
    return this;
  }

  /** @internal */
  public _get_encoded_size(): number {
    let total_size = 0;
    total_size += 4 + new TextEncoder().encode(this.channel).length + 1;
    const v_num_encoded_msg = this.encoded_msg.length;
    total_size += 4;
    total_size += 1 * v_num_encoded_msg;
    return total_size;
  }

  public override encode(): ArrayBufferLike {
    const encoder = new Encoder(8 + this._get_encoded_size()); // hash + rest
    encoder.encode_hash(web_socket_msg_t._get_packed_fingerprint());
    this.encode_one(encoder);

    return encoder.view.buffer;
  }

  public override encode_one(encoder: Encoder): void {
    encoder.encode_string(this.channel);
    encoder.encode_int32_t(this.encoded_msg.length);
    encoder.encode_uint8_array(this.encoded_msg);
  }

  constructor(init?: {channel?: string, encoded_msg?: Uint8Array }) {
    super();
    this.channel = "";
    this.encoded_msg = new Uint8Array(0);

    // optionally override default values
    if (!init) {
      return;
    }
    this.channel = init.channel || this.channel;
    this.encoded_msg = init.encoded_msg || this.encoded_msg;
  }
}